import React, { useState } from "react";
const logo = require("assets/images/logo.png/");

const Preview = (props: any) => {
  const { selectedRow } = props;
  // const [total, setTotal] = useState<any>("");
  let cgst = 0;
  let sgst = 0;
  let qty = 0;
  let rate = 0;
  let totalAmt = 0;
  for (let i = 0; i < selectedRow.items.length; i++) {
    qty += selectedRow.items[i].soldSku;
    rate += selectedRow.items[i].price;
    cgst += Number(selectedRow.items[i].itemcgstAmount);
    sgst += Number(selectedRow.items[i].itemsgstAmount);
    totalAmt += Number(selectedRow.items[i].orderItemTotal);
  }

  const generateTable = () => {
    const orderItem = selectedRow;
    console.log("orderItem", orderItem);
    const table = [];
    let basic = 0;
    let taxAmount = 0;
    let slno = 0;
    // let taxPercent = 0;
    //let Total = 0;
    // orderItem[i]["slNo"] = i + 1;
    // Total += Number(orderItem[i].total);

    orderItem.items &&
      orderItem.items.map((item, index) => {
        slno = slno + 1;
        const row = [];

        const taxPercent = Number(
          (
            (Number(item.orderItemTaxAmount) / Number(item.orderItemBasic)) *
            100
          ).toFixed(2)
        );
        let cell = (
          <tr>
            <td align="center" width={"5%"}>
              {slno}
            </td>
            <td align="center">{orderItem.hsn}</td>
            <td> {item.productName}</td>
            <td align="center">{item.soldSku}</td>
            <td align="center">{item.price}</td>
            <td align="center">{taxPercent / 2}</td>
            <td align="center">{Number(item.itemcgstAmount).toFixed(2)}</td>
            <td align="center">{taxPercent / 2}</td>
            <td align="center">{Number(item.itemsgstAmount).toFixed(2)}</td>
            <td align="center">{Number(item.orderItemTotal).toFixed(2)}</td>
          </tr>
        );
        row.push(cell);

        return table.push(row);
      });

    return table;
  };

  return (
    <div id="salesInvoiceBill">
      <div
        className="mainBody"
        style={{
          paddingBottom: "10px",
          marginBottom: "10px",
          height: 750,
          bottom: 50,
        }}
      >
        <table border={1} cellSpacing={0} cellPadding={5} width="100%">
          <tr>
            <td colSpan={8} className="headingFont" height="30px">
              PARAS AGENCIES Vijayapura Karnataka <br />
              PLOT NO.83, KIRANA MARCHANT ASSOCIATION LAYOUT KIADB <br />
              INDUSTRIAL AREA VIJAYAPURA, KARNATAKA
              <br />
              Vijayapura Mo.: 9902420444 GN Traders
            </td>
            <td colSpan={2}>
              <img src={logo} width="120px" height="100px" />
            </td>
          </tr>
          <tr>
            <td colSpan={8} className="headingFont">
              G N Traders
            </td>
            <td colSpan={2} className="headingFont">
              TAX INVOICE
            </td>
          </tr>
          <tr>
            <td colSpan={8}>
              <span className="headingFont">Address :</span>{" "}
              <span style={{ fontSize: " 1.1rem" }}>
                Bus stand in side Vijayapura
              </span>
              <br />
              <span className="headingFont">GST NO. :</span>
              <span style={{ fontSize: " 1.1rem" }}>29BANPK1881M2ZY</span>
              <br />
              <span className="headingFont">Food License No. :</span>
              <span style={{ fontSize: " 1.1rem" }}> </span>
            </td>
            <td colSpan={2} className="headingFont">
              <span>Bill No:</span> <span>{selectedRow.orderNumber}</span>
            </td>
          </tr>
          <tr>
            <td colSpan={8} className="headingFont">
              <span>Phone:</span> <span>8660830446-Moulali</span>
            </td>
            <td colSpan={2} className="headingFont">
              Dt.: <span>{selectedRow.orderDate}</span>
            </td>
          </tr>
          <tr>
            <td rowSpan={2} className="headingFont" width="4%">
              No.
            </td>
            <td rowSpan={2} className="headingFont" width="12%">
              HSN
            </td>
            <td rowSpan={2} className="headingFont" width="40%">
              Item Name
            </td>
            <td rowSpan={2} className="headingFont" width="5%">
              Qty
            </td>
            <td rowSpan={2} className="headingFont" width="8%">
              Rate
            </td>
            <td className="headingFont" width="" colSpan={2}>
              CGST
            </td>
            <td className="headingFont" width="" colSpan={2}>
              SGST
            </td>
            <td rowSpan={2} className="headingFont" width="">
              Total
            </td>
          </tr>
          <tr>
            <td className="headingFont" width="4%">
              %
            </td>
            <td className="headingFont" width="4%">
              Amt
            </td>
            <td className="headingFont" width="4%">
              %
            </td>
            <td className="headingFont" width="4%">
              Amt
            </td>
          </tr>

          <tbody>{generateTable()}</tbody>
          <tr>
            <td colSpan={3} className="headingFont">
              Round Off
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="headingFont">0.48</td>
          </tr>
          <tr>
            <td colSpan={3} className="headingFont">
              Invoice Total
            </td>
            <td className="headingFont">{qty}</td>
            <td className="headingFont">{rate}</td>
            <td className="headingFont"></td>
            <td className="headingFont">{cgst}</td>
            <td className="headingFont"></td>
            <td className="headingFont">{sgst}</td>
            <td className="headingFont">
              <span> ₹ </span>&nbsp;<span>{totalAmt}</span>
            </td>
          </tr>
        </table>

        <table
          className="table"
          border={1}
          cellSpacing={0}
          cellPadding={5}
          width="100%"
        >
          <tr>
            <td width="15%" className="headingFont">
              Item
            </td>
            <td width="15%" className="headingFont">
              Wafer
            </td>
            <td width="15%" className="headingFont">
              Flour
            </td>
            <td width="15%" className="headingFont">
              Papad
            </td>
            <td width="15%" className="headingFont">
              Namkeen
            </td>
            <td width="15%" className="headingFont">
              Wshngabr
            </td>
            <td width="10%" className="headingFont">
              Total
            </td>
          </tr>
          <tr>
            <td width="15%">10RS</td>
            <td width="15%">84</td>
            <td width="15%">24</td>
            <td width="15%">108</td>
            <td width="15%">84</td>
            <td width="15%">24</td>
            <td width="15%">108</td>
          </tr>
          <tr>
            <td width="15%">10GM</td>
            <td width="15%">84</td>
            <td width="15%">24</td>
            <td width="15%">108</td>
            <td width="15%">84</td>
            <td width="15%">24</td>
            <td width="15%">108</td>
          </tr>
          <tr>
            <td width="15%">10GM</td>
            <td width="15%">84</td>
            <td width="15%">24</td>
            <td width="15%">108</td>
            <td width="15%">84</td>
            <td width="15%">24</td>
            <td width="15%">108</td>
          </tr>
        </table>
        <table
          className="table"
          border={1}
          cellSpacing={0}
          cellPadding={5}
          width="100%"
        >
          {/* <p style={{ pageBreakBefore: "avoid" }}></p> */}
          <tr style={{ height: "60" }}>
            <td>
              <div
                className="headingFont"
                style={{ marginBottom: "30px", width: "70%" }}
              >
                PARAS AGENCIES Vijayapura Karnataka
              </div>
              <br />
              <div style={{ marginTop: "30px" }}>(Authorized Signatory)</div>
            </td>
            <td valign="top" width="30%" className="headingFont">
              Comments :
            </td>
          </tr>
          <tr>
            <td className="headingFont">
              <span>Generated On:</span>
              <span>10/04/2023 20:23:43</span>
            </td>
            <td className="headingFont">
              <span>Shop Close Time :</span>
              <span></span>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <span>GSTIN :</span>
              <span>29CZWPS3897J1ZW ,</span>
              &nbsp;
              <span>FSSAI No. :</span>
              <span>11222307000303</span>
              &emsp;
              <span>* Check out the goods</span>
              &nbsp;
              <span>* Subject to the Vijayapura Jurisdiction.</span>
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="headingFont">
              <span>Order By: -</span>
              <span>8710-SO-Mohamad Arif Mujawar</span>
              &ensp;
              <span>Mobile No .: -</span>
              <span>9902420444</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Preview;
